export default {
      id: "flex-alignContent-center-usage",
      viewBox: "0 0 40 40",
      url: "assets/" + "sprite.svg#flex-alignContent-center-usage",
      toString: function () {
        return this.url;
      }
    }